export default __webpack_public_path__ + "static/media/der.ddcba5b6.png";